import React from 'react'
import { Link, useLocation } from "react-router-dom";
const Sidebar = ({ CustomerProfileData }) => {
    const location = useLocation();
    return (
        <>
            <div className="sidebar" id="sidebar">
                <div className="sidebar-inner slimscroll">
                    <div id="sidebar-menu" className="sidebar-menu">
                        <ul>
                            <li className="clinicdropdown">
                                <Link to="/customer-dashboard/profile">
                                    {/* <img
                                        src="/assets/img/profiles/avatar-14.jpg"
                                        className="img-fluid"
                                        alt="Profile"
                                    /> */}
                                    <div className="user-names">
                                        <h5>
                                            {CustomerProfileData?.customerType === 'Individual/Proprietary firm'
                                                ? (CustomerProfileData?.individualName || CustomerProfileData?.username)
                                                : (CustomerProfileData?.name || CustomerProfileData?.username)
                                            }
                                            {
                                                (CustomerProfileData?.profileCompleted && CustomerProfileData.approval === "APPROVED") && <i className="fa-solid fa-circle-check ms-1" style={{ color: "#1da701" }}></i>
                                            }
                                        </h5>

                                        <h6>{CustomerProfileData?.customerType}</h6>
                                    </div>
                                </Link>
                            </li>
                        </ul>
                        <ul>
                            <li>
                                <h6 className="submenu-hdr">Main Menu</h6>
                                {/* <ul>

                                    <li className={location.pathname === "/customer-dashboard/dashboard" ? 'active-link' : ''}>
                                        <Link to="/customer-dashboard/dashboard">
                                            <i className="ti ti-brand-airtable" />
                                            <span>Dashboard</span>

                                        </Link>

                                    </li>


                                </ul> */}
                                <ul>
                                    <li className={location.pathname === "/customer-dashboard/profile" ? 'active-link' : ''}>
                                        <Link to="/customer-dashboard/profile">
                                            <i className="fa-solid fa-user" />
                                            <span>Profile</span>
                                        </Link>

                                    </li>
                                </ul>
                                <ul>
                                    <li className={location.pathname === "/customer-dashboard/documents" ? 'active-link' : ''}>
                                        <Link to="/customer-dashboard/documents">
                                            <i className="fa-solid fa-file" />
                                            <span>KYC Documents</span>
                                        </Link>

                                    </li>
                                </ul>
                                {CustomerProfileData?.profileCompleted && CustomerProfileData?.approval == 'APPROVED' && CustomerProfileData?.status &&
                                    <>
                                        <ul>
                                            <li className={location.pathname === "/customer-dashboard/contract-list" ? 'active-link' : ''}>
                                                <Link to="/customer-dashboard/contract-list">
                                                    <i className="fa-solid fa-file-contract" />
                                                    <span>Contract Management</span>
                                                </Link>

                                            </li>
                                        </ul>
                                        <ul>
                                            <li className={location.pathname === "/customer-dashboard/query-list" ? 'active-link' : ''}>
                                                <Link to="/customer-dashboard/query-list">
                                                    <i className="fa-solid fa-quote-left" />
                                                    <span>Query List</span>
                                                </Link>

                                            </li>
                                        </ul>
                                        {/* <ul>
                                            <li className={location.pathname === "/customer-dashboard/all-orders" ? 'active-link' : ''}>
                                                <Link to="/customer-dashboard/all-orders">
                                                    <i className="ti ti-brand-airtable" />
                                                    <span>Order Management</span>
                                                </Link>

                                            </li>
                                        </ul> */}
                                    </>

                                }
                                {/* <ul>

                                    <li className="submenu">
                                        <a href="javascript:void(0);">
                                            <i className="ti ti-brand-airtable" />
                                            <span>Customer Registration</span>
                                            <span className="menu-arrow" />
                                        </a>
                                        <ul>
                                            <li>
                                                <Link to="/customer/customer-registration" className="active">Registration form</Link>
                                            </li>
                                            <li>
                                                <Link to="#">My Quotation List</Link>
                                            </li>

                                        </ul>
                                    </li>


                                </ul> */}
                            </li>
                            {/* <li>
                                <h6 className="submenu-hdr">Menu</h6>
                                <ul>
                                    <li className="submenu">
                                        <a href="javascript:void(0);">
                                            <i className="ti ti-brand-airtable" />
                                            <span>History</span>
                                            <span className="menu-arrow" />
                                        </a>
                                        <ul>
                                            <li>
                                                <Link to="#">Payments</Link>
                                            </li>
                                            <li>
                                                <Link to="#">Emails</Link>
                                            </li>
                                            <li>
                                                <Link to="#">Order History</Link>
                                            </li>
                                        </ul>
                                    </li>
                                </ul>
                            </li> */}
                        </ul>
                    </div>
                </div >
            </div >
        </>
    )
}

export default Sidebar